import { generateUniqueId } from 'app/functions';
import Benefit from 'containers/shared/benefit/benefit';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import DealCard from '../DealCard';
import { AnalyticsParamValues } from '../../../../../../constants/analytics';
import './index.scss';

const DealsStrip = (props) => {
    const { deals, className = '' } = props;
    const cardsRef = useRef();
    const [scrollX, setScrollX] = useState(0);
    const [isScrolling, setIsScrolling] = useState(false);
    const [startX, setStartX] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const deviceState = useSelector(store => store.state.deviceState);

    useEffect(() => {
        if(deviceState === 'mobile'){
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    },[deviceState])

    const onMouseDown = (e) => { 
        if(isMobile){
            setIsScrolling(true);
            setStartX(e.clientX);
        }
    }
 
    const onMouseUp = (e) => { 
        if(isMobile){
            setIsScrolling(false);
        }
    }
 
    const onMouseMove = (e) => { 
        if(isScrolling && isMobile){
            let newScrollX = scrollX - e.clientX + startX;
            let scrollLeft = -1 * cardsRef.current.scrollLeft;
            let scrollWidth = cardsRef.current.scrollWidth;
            let offsetWidth = cardsRef.current.offsetWidth;
            let leftScrolled = scrollLeft + offsetWidth;
            if(leftScrolled <= scrollWidth  && leftScrolled >= 0){
                if(leftScrolled < scrollWidth && leftScrolled > 0){
                    setScrollX(newScrollX);
                    setStartX(e.clientX);  
                }
                cardsRef.current.scroll(newScrollX, 0)
            }
        }
    }

    const scrollEvent = (e) => { 
        // let scrollLeft = e.target.scrollLeft;
        // setScrollX(scrollLeft);
        // setStartX(e.clientX);
    }

    

    return (
        <div 
            className={`cards-wrapper ${className}`}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
            // style={{
            //     marginRight: scrollX
            // }}
            ref={cardsRef}
        >
            {deals.map((deal) => (
                <Benefit
                    key={deal.id}
                    data={deal}
                    analyticsSource={AnalyticsParamValues.MAGAZINE_ARTICLE_PAGE_SOURCE}
                />
            ))}
        </div>
        );
}

export default DealsStrip;
